var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardActionRequired = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_8182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99316 21H19.932C21.5619 21 22.5779 19.2325 21.763 17.8249L13.7935 4.05571C12.9786 2.6481 10.9466 2.6481 10.1316 4.05571L2.16221 17.8249C1.34727 19.2325 2.3633 21 3.99316 21ZM11.9625 13.5915C11.3804 13.5915 10.9041 13.1153 10.9041 12.5332V10.4165C10.9041 9.83436 11.3804 9.3581 11.9625 9.3581C12.5446 9.3581 13.0208 9.83436 13.0208 10.4165V12.5332C13.0208 13.1153 12.5446 13.5915 11.9625 13.5915ZM10.9041 17.8249H13.0208V15.7082H10.9041V17.8249Z",
    fill: "#A12885"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_8182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardActionRequired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-action-required.1da8bd9cf527b2bf66c58fc3c022dd3e.svg";